(() => {
  const init = () => {
    document.querySelectorAll('.product-modern .dome-pack-options').forEach(group => {
      const sync = () => group.querySelectorAll('.dome-pack-option').forEach(option => {
        option.setAttribute('aria-pressed', String(option.classList.contains('selected')));
      });
      sync();
      new MutationObserver(sync).observe(group, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    document.querySelectorAll('.product-modern .product-page .quantity-minus, .product-modern .product-page .quantity-plus').forEach(control => {
      control.setAttribute('role', 'button');
      control.setAttribute('aria-label', control.classList.contains('quantity-minus') ? 'Menge verringern' : 'Menge erhöhen');
      control.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); control.click(); }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(() => {

  function setupCompatibility(root) {
    root.querySelectorAll('[data-tab-anchor~="kompatibilitaet"] .meta-field').forEach((source, index) => {
      if (source.dataset.pmSearchReady) return;
      const lists = Array.from(source.querySelectorAll('ul, ol')).filter(list => !list.parentElement.closest('li'));
      if (!lists.length) return;
      source.dataset.pmSearchReady = 'true';
      const groups = document.createElement('div');
      groups.className = 'pm-compat-groups';
      const entries = [];
      lists.forEach(list => {
        const wrapper = list.closest('.grid-item');
        let heading = wrapper ? wrapper.querySelector('h2,h3,h4') : null;
        if (!heading) {
          let previous = list.previousElementSibling;
          while (previous && !/^H[2-4]$/.test(previous.tagName)) previous = previous.previousElementSibling;
          heading = previous;
        }
        const title = heading ? heading.textContent.trim() : 'Weitere Modelle';
        const section = document.createElement('section');
        section.className = 'pm-compat-group';
        const h3 = document.createElement('h3'); h3.textContent = title; section.append(h3);
        const copy = list.cloneNode(true); copy.removeAttribute('style'); copy.removeAttribute('id');
        Array.from(copy.querySelectorAll('li')).forEach(item => { entries.push({ item, section, model: item.textContent }); });
        section.append(copy); groups.append(section);
      });
      if (!entries.length) return;
      // Preserve the original content; present every model in its brand group.
      source.querySelectorAll('style').forEach(style => { style.media = 'not all'; });
      source.hidden = true;
      source.after(groups);
      const help = document.createElement('p'); help.className = 'pm-compat-search__help';
      help.append(document.createTextNode('Modell nicht gefunden oder Ausführung unklar? '));
      const phone = document.createElement('a'); phone.href = 'tel:094529399227'; phone.textContent = 'Wir helfen Ihnen: 09452 / 9399227'; help.append(phone); groups.after(help);
    });
  }

  function setupProduct(root) {
    if (root.dataset.pmRefinedReady) return;
    root.dataset.pmRefinedReady = 'true';
    const form = root.querySelector('.content-summary > form.product-form');
    if (!form) return;
    const wrappers = Array.from(form.querySelectorAll('.selector-wrapper[data-n-opt]'));
    const receiver = root.dataset.pmReceiver === 'true';
    wrappers.forEach(wrapper => {
      const name = wrapper.dataset.nOpt;
      const label = wrapper.querySelector('label[for]');
      if (receiver && name === 'Bauform' && label) label.textContent = 'Leistungsstufe:';
      if (receiver && ['Bauform', 'Seite', 'Länge'].includes(name)) {
        const hint = document.createElement('p'); hint.className = 'pm-option-hint';
        hint.textContent = name === 'Bauform' ? 'Kennzeichnung am bisherigen Hörer übernehmen.' : name === 'Seite' ? 'Für welches Ohr benötigen Sie den Hörer?' : 'Längenangabe des bisherigen Hörers vergleichen.';
        wrapper.append(hint);
      }
    });
    const productId = root.dataset.productId;
    function syncSelection() {
      const parts = wrappers.map(wrapper => {
        const original = wrapper.dataset.nOpt;
        const name = (receiver || root.classList.contains('pr5-product')) && original === 'Bauform' ? 'Leistung' : original;
        if (wrapper.classList.contains('op_pre_select')) {
          const placeholder = wrapper.querySelector('.js-change-label');
          if (placeholder && placeholder.textContent !== 'Bitte auswählen') placeholder.textContent = 'Bitte auswählen';
          return original + ' auswählen';
        }
        const select = wrapper.querySelector('select') || form.querySelector('select[data-js-selector="' + wrapper.dataset.jsOpt + '"]');
        const value = select ? select.value : wrapper.querySelector('.js-change-label')?.textContent.trim();
        return value ? name + ': ' + value : '';
      }).filter(Boolean);
      document.querySelectorAll('[data-pm-selection]').forEach(node => {
        if (node.dataset.pmProduct !== productId) return;
        const text = parts.join(' · ');
        if (node.textContent !== text) node.textContent = text;
      });
    }
    let frame = false;
    const schedule = () => { if (frame) return; frame = true; requestAnimationFrame(() => { frame = false; syncSelection(); }); };
    new MutationObserver(schedule).observe(form, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true, characterData: true });
    form.addEventListener('change', schedule);
    syncSelection();
    if (window.jQuery) {
      window.jQuery(form).on('variantChange.pmProductRefinements', event => {
        if (event.target.closest('.product-inner') !== root || !event.variant) return;
        root.querySelectorAll('.content-summary .product_delivery').forEach(delivery => { delivery.hidden = !event.variant.available; });
        schedule();
      });
    }
    setupCompatibility(root);
  }

  function initRefinements() {
    document.querySelectorAll('.product-modern .product-page.psgl-ly-7').forEach(setupProduct);
    document.querySelectorAll('.product-modern .entry-price > ins, .product-modern .entry-price > del').forEach(node => {
      if (node.dataset.pmMoneyReady) return; node.dataset.pmMoneyReady = 'true';
      const format = () => { const text = node.textContent.replace(/(\d)\s*€/g, '$1\u00a0€'); if (text !== node.textContent) node.textContent = text; };
      new MutationObserver(format).observe(node, { childList: true, characterData: true, subtree: true });
      format();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRefinements);
  else initRefinements();
  document.addEventListener('shopify:section:load', initRefinements);
})();
